type AlmanacLogoProps = {
  compact?: boolean;
  className?: string;
};

export function AlmanacLogo({ compact = false, className }: AlmanacLogoProps) {
  const width = compact ? 36 : 188;
  const height = compact ? 36 : 50;

  if (compact) {
    return (
      <img
        src="/brand/almanac-icon.svg"
        alt="Almanac"
        width={width}
        height={height}
        className={className}
        decoding="async"
      />
    );
  }

  return (
    <span className={className}>
      <img
        src="/brand/almanac-wordmark-dark.svg"
        alt="Almanac"
        width={width}
        height={height}
        className="dark:hidden"
        decoding="async"
      />
      <img
        src="/brand/almanac-wordmark-white.svg"
        alt="Almanac"
        width={width}
        height={height}
        className="hidden dark:block"
        decoding="async"
      />
    </span>
  );
}
